import { RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { MfaTotpVerify } from "./MfaTotpVerify";
import { routes } from "./MfaTotpVerify.Parts";

// LOADER

// WRAPPER

// ROUTE
export const MfaTotpVerifyRouteObject: RouteObject = {
  path: routes.mfa.totp.verify,
  errorElement: <GeneralErrorPage />,
  Component: MfaTotpVerify,
};
